export default (theme: any) => ({
    DemoModeStartDialog: {
        position: 'relative',
    },

    DemoModeStartDialogContainer: {
        width: '98%',
        maxHeight: '80%',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'space-between',
        flexDirection: 'column',
        padding: '.5rem',
        maxWidth: '98%',
        [theme.breakpoints.up('sm')]: {
            width: '80%',
        },
        [theme.breakpoints.up('md')]: {
            width: '70%',
            padding: '3rem',
        },
        [theme.breakpoints.up('lg')]: {
            width: '65%',
        },
    },

    DemoModeStartDialogTitleContainer: {
        marginBottom: '3rem',
        textAlign: 'center',
    },

    DemoModeStartDialogOverText: {},

    DemoModeStartDialogTitle: {
        fontSize: '2em',
        fontWeight: 'bold',
    },

    DemoModeStartDialogIntro: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        marginBottom: '1rem',
        [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {
            marginBottom: '6rem',
            padding: '0 3rem',
        },
    },

    DemoModeStartDialogButtons: {
        [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: '1rem',
        },
    },

    DemoModeStartDialogButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: ' 1rem 0',
        [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {
            padding: ' 0',
        },
    },

    DemoModeStartDialogButtonButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        background: theme.palette.consultation.main,
        [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {},
    },

    DemoModeStartDialogButtonButtonActive: {
        '&:hover': {
            background: `${theme.palette.consultation.ultraLight} !important`,
            '& svg *': {
                fill: `${theme.palette.consultation.main} !important`,
                stroke: `${theme.palette.consultation.main} !important`,
            },
            '& span': {
                color: theme.palette.consultation.main,
            },
        },
    },

    DemoModeStartDialogButtonDisabled: {},

    DemoModeStartDialogButtonButtonAlternative: {
        backgroundColor: `${theme.palette.primary.ultraLight} !important`,
        color: `${theme.palette.primary.main} !important`,
        [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {},
        '&:hover': {
            backgroundColor: `${theme.palette.primary.light} !important`,
        },
    },

    DemoModeStartDialogButtonButtonDisabled: {
        opacity: '0.4',
    },

    DemoModeStartDialogButtonDisabledText: {
        marginTop: '1rem',
    },

    DemoModeStartDialogErrorMessage: {
        marginTop: '1rem',
        color: theme.palette.error.main,
    },

    DemoModeStartDialogButtonIcon: {
        marginBottom: '1rem',
    },

    DemoModeStartDialogButtonIconHover: {
        display: 'none',
    },

    DemoModeStartDialogButtonIconIdle: {
        display: 'flex',
    },

    DemoModeStartDialogButtonText: {},
})
